import {PROFILE_FIELD_NAMES} from "./ProfileEnum";

const regex = {
  _email_regex: "^([a-zA-Z0-9]+)([\.{1}])?([a-zA-Z0-9]+)\@[\w\-]+([\.][\w\-]+)+$",
  _gmail_regex: "^([a-zA-Z0-9]+)([\.{1}])?([a-zA-Z0-9]+)\@gmail([\.])com$",
  _name_regex: "^[A-Za-z\s. ]{1,}$",
  _pan_regex: "^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$",
  _mobile_regex: "^([5-9]{1}[0-9]{9})$",
  _total_dependents_regex: "^([0-9]|9)$",
  _street_name_regex: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{3,60})$",
  _locality_regex: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{3,60})$",
  _landmark_regex: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{3,60})$",
  _pincode_regex: "^([0-9]{6})$",
  _house_no_regex: "^([a-zA-z0-9 . # @ & ( ) / , . : ' < > \- , \s]{1,60})$",
  _non_empty_regex: "^(?!\s*$).+",
  _non_empty_number_regex: "^[\d]{0,}.[\d]{0,}$",
  _act_number: "^[0-9a-zA-Z]{8,}$",
  _income_regex: "^([0-9]{1,})$",
  _work_experience: "^([01]?[0-9]?[0-9]|2[0-9][0-9]|300)$",
  _ifsc_regex: "^[A-Z]{4}0[A-Z0-9]{6}$",
  _aadhaar_regex: "^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$"
};

export const ProfileFieldRegex = {
  [PROFILE_FIELD_NAMES.FATHER_OR_SPOUSE_NAME]: regex._name_regex,
  [PROFILE_FIELD_NAMES.MOTHER_NAME]: regex._name_regex,
  [PROFILE_FIELD_NAMES.NAME]: regex._name_regex,
  [PROFILE_FIELD_NAMES.WORK_EXPERIENCE_MONTHS]: regex._work_experience,
  [PROFILE_FIELD_NAMES.HOUSE]: regex._house_no_regex,
  [PROFILE_FIELD_NAMES.STREET]: regex._street_name_regex,
  [PROFILE_FIELD_NAMES.LOCALITY]: regex._locality_regex,
  [PROFILE_FIELD_NAMES.LANDMARK]: regex._landmark_regex,
  [PROFILE_FIELD_NAMES.PINCODE]: regex._pincode_regex,
  [PROFILE_FIELD_NAMES.REFERENCE_NAME]: regex._name_regex,
  [PROFILE_FIELD_NAMES.REFERENCE_MOBILE]: regex._mobile_regex,
  [PROFILE_FIELD_NAMES.MOBILE]: regex._mobile_regex,
  [PROFILE_FIELD_NAMES.BENEFICIARY_NAME]: regex._name_regex,
  [PROFILE_FIELD_NAMES.ACCOUNT_NUMBER]: regex._act_number,
  [PROFILE_FIELD_NAMES.IFSC]: regex._ifsc_regex,
  [PROFILE_FIELD_NAMES.AMOUNT]: regex._income_regex,
  [PROFILE_FIELD_NAMES.TENURE]: regex._non_empty_regex,
  [PROFILE_FIELD_NAMES.AADHAAR]: regex._aadhaar_regex,
  [PROFILE_FIELD_NAMES.TOTAL_DEPENDENTS]: regex._total_dependents_regex,
  [PROFILE_FIELD_NAMES.PAN]: regex._pan_regex,
  [PROFILE_FIELD_NAMES.CAPTCHA]: regex._non_empty_regex
};
